// components/ui/CustomToast.tsx
import { useEffect, useState } from "react";
import { Toast } from "react-hot-toast";
import clsx from "clsx";
import { CrossSVG, InfoSVG, TikSVG } from "./SVG";

type ToastType = "success" | "error" | "info" | "default";

type CustomToastProps = {
  t: Toast;
  message: string;
  type?: ToastType;
  emoji?: string | React.ReactNode;
  duration?: number;
};

export default function CustomToast({
  t,
  message,
  type = "default",
  emoji,
  duration = 300,
}: CustomToastProps) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!t.visible) {
      const timeout = setTimeout(() => setVisible(false), duration);
      return () => clearTimeout(timeout);
    }
  }, [t.visible, duration]);

  if (!visible) return null;

  return (
    <div
      className={clsx(
        t.visible ? "animate-enter" : "animate-leave",
        "w-full bg-white shadow-lg rounded-lg border p-2 border-gray-200 text-slateCustom"
      )}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-medium">
          {emoji && (
            <span className="text-lg">
              {typeof emoji === "string" ? emoji : emoji}
            </span>
          )}
          <span>
            {type === "success" ? (
              <TikSVG className="w-3" />
            ) : type === "error" ? (
              <CrossSVG className="w-3" />
            ) : type === "info" ? (
              <InfoSVG className="w-5" />
            ) : null}
          </span>
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
}
